var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeHidden = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.891 6.764a20.3 20.3 0 0 1 3.65 3.402S17.822 16.125 12 16.125a9.5 9.5 0 0 1-2.75-.426m-4.155-2.141a20.3 20.3 0 0 1-3.637-3.392S6.177 4.208 12 4.208a9.2 9.2 0 0 1 2.291.298m-5.958 5.66A3.666 3.666 0 0 1 12 6.5m3.666 3.666A3.666 3.666 0 0 1 12 13.833",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.938 1.229 3.063 19.104"
}))));
export { SvgEyeHidden as ReactComponent };
export default __webpack_public_path__ + "assets/images/eye-hidden.svg";